export default "__VITE_ASSET__b425a086__"